var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.947,
    height: 16.943,
    viewBox: "0 0 16.947 16.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_122",
    "data-name": "Caminho 122",
    d: "M.575,8.907,8.907.566a1.98,1.98,0,0,1,2.771,0V.575l.005-.009,4.689,4.7.048.042a2,2,0,0,1,.527,1.343,1.913,1.913,0,0,1-.575,1.381v0L8.04,16.372l-.051.038a1.936,1.936,0,0,1-1.335.533,1.979,1.979,0,0,1-1.39-.57l-4.689-4.7A1.95,1.95,0,0,1,0,10.293,1.976,1.976,0,0,1,.575,8.907m13.789,6.706h0a.664.664,0,1,1-.669.665.666.666,0,0,1,.669-.665m-2.13,0h0a.664.664,0,1,1,0,1.329.664.664,0,1,1,0-1.329m-2.125,0h0a.664.664,0,0,1,0,1.329.664.664,0,1,1,0-1.329M3.817,7.545h0l5.589,5.58L15.434,7.1a.645.645,0,0,0,.184-.448.679.679,0,0,0-.165-.429l-.02-.019L10.745,1.5a.632.632,0,0,0-.452-.175.611.611,0,0,0-.444.175Zm5.024,6.141h0L3.261,8.111,1.512,9.845a.647.647,0,0,0-.183.448.621.621,0,0,0,.183.443l4.69,4.7a.633.633,0,0,0,.452.179.588.588,0,0,0,.42-.16l.023-.019Z",
    fill: "#d60323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErase);
export default __webpack_public_path__ + "static/media/erase.03c2c81429196156b5ff658daa7bab0b.svg";
export { ForwardRef as ReactComponent };